import React from 'react';

function Title(props) {
  return (
    <h2 className="title is-3">{props.label}</h2>
  )
}

export default Title;
